import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import ViewReceipt from './components/ViewReceipt';
import { handleUrl } from './components/handleOpenMultipay';
import ChangeTxn from './components/ChangeTxn';
import ViewPaymentLogs from './components/ViewPaymentLogs';
import ChangeAmount from './components/ChangeAmount';
import * as action from './actions';
import * as c from './constants';

function PaymentInquiryContainer({
  findPayment,
  searching,
  tagAsForPosting,
  posting,
  findingLogs,
  viewPaymentLogs,
  findingLogsForTxn,
  viewPaymentLogsForTxn,
  permissions,
  postPaymentToQpax,
  manualExpireRefno,
  approveRefund,
  refunding,
  viewPaymentLogsForAmount,
  findingLogsForAmount,
  reassess
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({});
  const [paymentInfo, setPaymentInfo] = useState({});
  const [taxPayerInfo, setTaxPayerInfo] = useState({});
  const [taxPayerInfoIsPosted, setTaxPayerInfoIsPosted] = useState('');
  const [transId, setTransId] = useState({});

  const onFindPayment = e => {
    e.preventDefault();
    findPayment(formData, res => {
      setTransId(_.get(res, 'res.data.id'));
      setPaymentInfo(_.get(res, 'res.data.attributes') || {});
      setTaxPayerInfo(_.get(res, 'res.res.included[0].attributes') || {});
      setTaxPayerInfoIsPosted(
        _.get(res, 'res.res.included[1].attributes') || ''
      );
    });
  };

  const handlePostPaymentToQpax = e => {
    e.preventDefault();
    const args = {
      refno:
        _.get(paymentInfo, 'txnid') ||
        _.get(paymentInfo, 'refno') ||
        _.get(formData, 'refno'),
    };
    postPaymentToQpax(args, res => {
      const msg = _.get(res, 'res.res.message');
      if (msg === 'This transaction is already posted.') {
        setPaymentInfo({
          ...paymentInfo,
          transaction_status: 'PAID',
        });
      }
    });
  };

  const handleViewReceipt = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewReceipt receiptUrl={data} />,
      title: 'View Uploaded Receipt',
      modalSize: 'modal-md',
    });
  };

  const handleClear = e => {
    e.preventDefault();
    setFormData({
      refno: '',
    });
    setPaymentInfo('');
  };

  const handleChangeTxn = e => {
    e.preventDefault();

    const args = {
      refno:
        _.get(paymentInfo, 'txnid') ||
        _.get(paymentInfo, 'refno') ||
        _.get(formData, 'refno'),
    };

    viewPaymentLogsForTxn(args, res => {
      setModal({
        isOpen: true,
        content: (
          <ChangeTxn transactionId={transId} logs={res} onClear={handleClear} />
        ),
        title: 'Change TXNID',
        modalSize: 'modal-md',
      });
    });
  };

  const handleChange = e => {
    if (_.get(formData, 'refno') !== e.target.value) {
      setFormData({
        refno: '',
      });
      setPaymentInfo('');
    }
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleViewPaymentLogs = e => {
    e.preventDefault();
    const args = {
      refno:
        _.get(paymentInfo, 'txnid') ||
        _.get(paymentInfo, 'refno') ||
        _.get(formData, 'refno'),
    };

    viewPaymentLogs(args, res => {
      setModal({
        isOpen: true,
        content: (
          <ViewPaymentLogs
            logs={_.get(res, 'res.data')}
            paymentLogs={_.get(res, 'res.res.transactions')}
          />
        ),
        title: 'View Payment Logs',
        modalSize: 'modal-xl',
      });
    });
  };

  const handleTagforPosting = e => {
    e.preventDefault();
    const args = {
      refno:
        _.get(paymentInfo, 'txnid') ||
        _.get(paymentInfo, 'refno') ||
        _.get(formData, 'refno'),
    };
    tagAsForPosting(args, res => {
      const msg = _.get(res, 'res.res.message');
      if (msg === 'Transaction is now ready for posting!') {
        setPaymentInfo({
          ...paymentInfo,
          transaction_status: 'WAITING FOR PAYMENT',
        });
      }
    });
  };

  const handleManualExpireRefno = e => {
    e.preventDefault();
    const args = {
      refno:
        _.get(paymentInfo, 'txnid') ||
        _.get(paymentInfo, 'refno') ||
        _.get(formData, 'refno'),
    };
    manualExpireRefno(args);
  };

  const handleApproveRefund = e => {
    e.preventDefault();
    const args = {
      refno: _.get(paymentInfo, 'txnid'),
    };
    approveRefund(args, () => {
      findPayment(args, res => {
        setTransId(_.get(res, 'res.data.id'));
        setPaymentInfo(_.get(res, 'res.data.attributes') || {});
        setTaxPayerInfo(_.get(res, 'res.res.included[0].attributes') || {});
        setTaxPayerInfoIsPosted(
          _.get(res, 'res.res.included[1].attributes') || ''
        );
      });
    });
  };

  const handleChangeAmount = e => {
    e.preventDefault();

    const args = {
      refno: _.get(paymentInfo, 'txnid'),
    };

    viewPaymentLogsForAmount(args, res => {
      setModal({
        isOpen: true,
        content: (
          <ChangeAmount
            transactionId={transId}
            logs={res}
            onClear={handleClear}
          />
        ),
        title: 'Change Amount',
        modalSize: 'modal-md',
      });
    });
  };

  const onRollback = item => e => {
    e.preventDefault();

    const args = {
      refno: item
    }

    e.preventDefault();
    ConfirmAlert(
      `Are you sure, you want to reassess this application?`,
      () => {
        reassess(args, () => {
          handleClear(e)
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const pStatus = _.get(paymentInfo, 'status');
  const tStatus = _.get(paymentInfo, 'transaction_status');

  return (
    <div className="payment">
      <div className="container">
        <form
          onSubmit={onFindPayment}
          className="form-inline my-2 my-lg-0 d-flex justify-content-center"
        >
          <div className="mt-3 input-group mb-3 col-md-6 payments__form-bg">
            <div className="input-group-prepend">
              <label className="payments__number-icon">#</label>
            </div>
            <input
              name="refno"
              onChange={handleChange}
              value={_.get(formData, 'refno') || ''}
              required
              type="text"
              style={{ border: 'none', marginRight: '10px' }}
              className="form-control"
              placeholder="Enter REFERENCE NUMBER or TXNID "
              aria-describedby="basic-addon2"
            />
            {_.isEmpty(paymentInfo) && (
              <div className="input-group-append">
                <button
                  disabled={searching}
                  type="submit"
                  className="mr-3 btn btn-primary cms-bg-color-primary cms-outline-primary "
                >
                  {searching ? (
                    <i className="fa fa-spin fa-spinner" />
                  ) : (
                    <>
                      Verify <i className="fas fa-check" />
                    </>
                  )}
                </button>
              </div>
            )}
            {!_.isEmpty(paymentInfo) && (
              <div className="input-group-append">
                <button
                  onClick={handleClear}
                  type="submit"
                  className="mr-3 btn btn-danger"
                >
                  CLEAR <i className="fas fa-times" />
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
      {!_.isEmpty(paymentInfo) && (
        <div className="payments__summary">
          <div className="payments__summary-title"> TRANSACTION SUMMARY </div>
          <hr className="stiches" />
          <table className="table borderless">
            <tbody>
              <tr>
                <td>
                  <b>Permit Type:</b>
                </td>
                <td className="text-right">
                  {_.get(paymentInfo, 'permit_type') || 'N/A'}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Full Name:</b>
                </td>
                <td className="text-right">
                  {_.get(taxPayerInfo, '_full_name') || 'N/A'}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Status:</b>
                </td>
                <td className="text-right">
                  {_.get(paymentInfo, 'transaction_status') ===
                  'WAITING FOR PAYMENT'
                    ? 'READY FOR POSTING'
                    : _.get(paymentInfo, 'status') || 'PENDING'}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Email:</b>
                </td>
                <td className="text-right">
                  {_.get(taxPayerInfo, 'email') || 'N/A'}
                </td>
              </tr>
              <tr>
                <td>
                  <b>TXNID:</b>
                </td>
                <td className="text-right">
                  {_.get(paymentInfo, 'txnid') || 'N/A'}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Contact Number:</b>
                </td>
                <td className="text-right">
                  {`+${_.get(taxPayerInfo, 'mobile_number')}` || 'N/A'}
                </td>
              </tr>
              {taxPayerInfoIsPosted?.is_posted === undefined ? null : (
                <tr>
                  <td>
                    <b>Payment Posted:</b>
                  </td>
                  <td className="text-right">
                    {taxPayerInfoIsPosted?.is_posted === 0 ? 'No' : 'Yes'}
                  </td>
                </tr>
              )}
              <tr>
                <td>
                  <b>Amount:</b>
                </td>
                <td className="text-right">
                  <b>{_.get(paymentInfo, 'amount') || 'N/A'}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>Transaction Status:</b>
                </td>
                <td className="text-right">
                  <b>{_.get(paymentInfo, 'transaction_status') || 'N/A'}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>Remarks:</b>
                </td>
                <td className="text-right">
                  <pre>{_.get(paymentInfo, 'remarks') || 'N/A'}</pre>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="for-posting-wrap payment-button-container">
            {Acl(permissions, ['PAYMENT VIEW MULTIPAY']) && (
              <button
                type="button"
                className="btn btn-outline-primary w-100 mb-2"
                onClick={() => {
                  handleUrl('https://inquiry.multipay.ph');
                }}
              >
                <b>Open Multipay</b>
              </button>
            )}

            {_.get(paymentInfo, 'payment_receipt_url') &&
              Acl(permissions, ['PAYMENT VIEW RECEIPT']) && (
                <button
                  type="button"
                  className="btn btn-outline-primary w-100 mb-2"
                  onClick={handleViewReceipt(
                    _.get(paymentInfo, 'payment_receipt_url')
                  )}
                >
                  <b>View Payment Receipt</b>
                </button>
              )}
            {Acl(permissions, ['PAYMENT VIEW LOGS']) && (
              <button
                onClick={handleViewPaymentLogs}
                type="button"
                className="btn btn-outline-primary mb-2 w-100"
              >
                {findingLogs ? (
                  <>
                    <i className="fa fa-spin fa-spinner" /> &nbsp; Loading
                  </>
                ) : (
                  <b>View Payment Logs</b>
                )}
              </button>
            )}
            {Acl(permissions, ['PAYMENT CHANGE TXNID']) && (
              <button
                type="button"
                className="btn btn-outline-primary mb-2 w-100"
                onClick={handleChangeTxn}
              >
                {findingLogsForTxn ? (
                  <>
                    <i className="fa fa-spin fa-spinner" /> &nbsp; Loading
                  </>
                ) : (
                  <b>Change TXNID</b>
                )}
              </button>
            )}
            {_.get(paymentInfo, 'module_type') === 'NOV' &&
              taxPayerInfoIsPosted.is_posted === 0 && (
                <button
                  type="button"
                  className="btn btn-outline-primary mb-2 w-100"
                  onClick={handlePostPaymentToQpax}
                >
                  <b>Post Payment To QPAX</b>
                </button>
              )}

            {tStatus === 'EXPIRED REFERENCE NUMBER' ||
            tStatus === 'PENDING' ||
            pStatus === 'PENDING' ||
            !pStatus ? (
              <button
                onClick={handleTagforPosting}
                type="button"
                className="btn btn-outline-primary w-100"
              >
                {posting ? (
                  <>
                    <i className="fa fa-spin fa-spinner" /> &nbsp; Loading
                  </>
                ) : (
                  <b>Tag as for Posting</b>
                )}
              </button>
            ) : (
              ''
            )}
            {tStatus === 'PENDING' ||
            tStatus === 'WAITING FOR PAYMENT' ||
            !pStatus ? (
              <button
                type="button"
                className="btn btn-outline-primary w-100 mt-2"
                onClick={handleManualExpireRefno}
              >
                <b>Expire Reference Number</b>
              </button>
            ) : (
              ''
            )}
            {tStatus === 'FOR REFUND APPROVAL' ? (
              <button
                type="button"
                className="btn btn-outline-primary w-100 mt-2"
                onClick={handleApproveRefund}
              >
                {refunding ? (
                  <>
                    <i className="fa fa-spin fa-spinner" /> &nbsp; Loading
                  </>
                ) : (
                  <b>Approve Refund Request</b>
                )}
              </button>
            ) : (
              ''
            )}
            {!_.get(paymentInfo, 'paid_at') &&
              Acl(permissions, ['PAYMENT CHANGE AMOUNT']) && (
                <button
                  type="button"
                  className="btn btn-outline-primary w-100 mt-2"
                  onClick={handleChangeAmount}
                >
                  {findingLogsForAmount ? (
                    <>
                      <i className="fa fa-spin fa-spinner" /> &nbsp; Loading
                    </>
                  ) : (
                    <b>Change Amount</b>
                  )}
                </button>
              )}
            {_.get(paymentInfo, 'module_type') === 'OHP' &&
                _.get(paymentInfo, 'transaction_status') !== 'PAID' &&
                _.get(paymentInfo, 'paid_at') &&
                Acl(permissions, ['REASSESS TRANSACTION']) && (
                  <button
                    type="button"
                    className="btn btn-outline-primary mb-2 w-100"
                    onClick={onRollback(_.get(paymentInfo, 'refno'))}
                  >
                    <b>Re Assess Transaction</b>
                  </button>
              )}
          </div>
        </div>
      )}
    </div>
  );
}

PaymentInquiryContainer.propTypes = {
  findPayment: PropTypes.instanceOf(Function).isRequired,
  tagAsForPosting: PropTypes.instanceOf(Function).isRequired,
  viewPaymentLogs: PropTypes.instanceOf(Function).isRequired,
  viewPaymentLogsForTxn: PropTypes.instanceOf(Function).isRequired,
  searching: PropTypes.bool.isRequired,
  posting: PropTypes.bool.isRequired,
  findingLogs: PropTypes.bool.isRequired,
  findingLogsForTxn: PropTypes.bool.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  postPaymentToQpax: PropTypes.instanceOf(Function).isRequired,
  manualExpireRefno: PropTypes.instanceOf(Function).isRequired,
  approveRefund: PropTypes.instanceOf(Function).isRequired,
  refunding: PropTypes.bool.isRequired,
  viewPaymentLogsForAmount: PropTypes.instanceOf(Function).isRequired,
  findingLogsForAmount: PropTypes.bool.isRequired,
  reassess: PropTypes.instanceOf(Function).isRequired
};

const mapStateToProps = ({ api }) => ({
  searching: api.loading.indexOf(c.FIND_PAYMENT) > -1,
  posting: api.loading.indexOf(c.TAG_FOR_POSTING) > -1,
  findingLogs: api.loading.indexOf(c.VIEW_PAYMENT_LOGS) > -1,
  findingLogsForTxn: api.loading.indexOf(c.VIEW_PAYMENT_LOGS_FOR_TXNID) > -1,
  refunding: api.loading.indexOf(c.APPROVE_REFUND) > -1,
  permissions: getJson('permissions'),
  findingLogsForAmount:
    api.loading.indexOf(c.VIEW_PAYMENT_LOGS_FOR_AMOUNT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(PaymentInquiryContainer);
